import { Component, OnInit } from '@angular/core';
import { CommonService } from "../../_services/common.service";
import { CommonProjectDataService } from "../../_services/common-project-data.service";
import { routerNgProbeToken } from '@angular/router/src/router_module';
import { Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { Title } from '@angular/platform-browser';


@Component({
  selector: 'app-store-home',
  templateUrl: './store-home.component.html',
  styleUrls: ['./store-home.component.css']
})
export class StoreHomeComponent implements OnInit {
  loading = false;
  public storeData: any = {};
  private future: Date;
  private futureString: string;
  private diff: number;
  private $counter: Observable<number>;
  private subscription: Subscription;
  private message: string;
  public days: number;
  public hours: number;
  public minutes: number;
  public seconds: number;
  selectedMockupImage = [];  
  public locationArr = [
    'front',
    'back',
    'left',
    'right'
  ];
  public notFound:boolean = false;

  constructor(private CommonService: CommonService,
    private CommonProjectDataService: CommonProjectDataService,
    private router: Router,
    private titleService: Title

  ) {

  }

  ngOnInit() {
    if (localStorage.getItem("userToken") == null) {
      this.loading = true;
      setTimeout(() => {
        this.getStoreDetail();
      }, 2000);
    }
    else {
      this.getStoreDetail();
    }
  }

  dhms(t) {
    // let days, hours, minutes, seconds;
    if (t > 0) {
      this.days = Math.floor(t / 86400);
      t -= this.days * 86400;
      this.hours = Math.floor(t / 3600) % 24;
      t -= this.hours * 3600;
      this.minutes = Math.floor(t / 60) % 60;
      t -= this.minutes * 60;
      this.seconds = t % 60;
    }
    else {
      this.days = 0;
      this.hours = 0;
      this.minutes = 0;
      this.seconds = 0;
    }



    return [
      this.days + 'd',
      this.hours + 'h',
      this.minutes + 'm',
      this.seconds + 's'
    ].join(' ');
  }

  getStoreDetail = function () {
    this.loading = true;
    this.CommonService.apiService(
      "GET",
      "store"
    ).subscribe(
      (response: any) => {
        this.loading = false;
        if (response.status === true && response.data) {
          this.storeData = response.data;
          if (this.storeData) {
            this.titleService.setTitle(this.storeData.name);
            $("#appPrintLifeFavicon").attr("href", this.storeData.favicon_img);
          }
          this.futureString = this.storeData.end_date;
          this.future = new Date(this.futureString);
          this.$counter = Observable.interval(1000).map((x) => {
            this.diff = Math.floor((this.future.getTime() - new Date().getTime()) / 1000);
            return x;
          });
          this.subscription = this.$counter
            .subscribe((x) => this.message = this.dhms(this.diff));
          localStorage.setItem("storeLogo", this.storeData.logo);
          localStorage.setItem("storeData", JSON.stringify(this.storeData));
          localStorage.setItem("userID", this.storeData.shop_id);
          // this.CommonProjectDataService.storeQuoteData(this.storeData);            
          this.CommonProjectDataService.storeLogo.next(this.storeData.logo);
        } else {
          this.storeURLNotFound();
        }
      },
      err => {
        this.loading = false;
        this.storeURLNotFound(err);
      }
    );
  }
  trackByFn(index: any, item: any) {
    return index;
  }
  viewProduct(projIndex: number, productIndex: number) {
    //localStorage.setItem("productIndex",productIndex);
    //localStorage.setItem("projIndex",projIndex);
    this.CommonProjectDataService.storeActiveProductIndex(productIndex);
    this.CommonProjectDataService.storeActiveProject(projIndex);
    this.router.navigate(["store/view-product"]);
  }
  showMockupImage(index, imageUrl) {
    this.selectedMockupImage[index] = imageUrl;
  }

  storeURLNotFound(error = null) {
    if (localStorage.getItem("userToken") == null) {
      location.reload();
    } else {
      this.notFound = true;
      this.router.navigate(["/store/not-found"]);
    }
  }


}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-store-product/store-home/store-home.component.ts